import { render } from "./UploadImportFormPopup.vue?vue&type=template&id=006be8eb&ts=true"
import script from "./UploadImportFormPopup.vue?vue&type=script&lang=ts"
export * from "./UploadImportFormPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__